import { render, staticRenderFns } from "./AccordionBase.vue?vue&type=template&id=0dc3f3d0&scoped=true&lang=pug&"
import script from "./AccordionBase.vue?vue&type=script&lang=ts&"
export * from "./AccordionBase.vue?vue&type=script&lang=ts&"
import style0 from "./AccordionBase.vue?vue&type=style&index=0&id=0dc3f3d0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc3f3d0",
  null
  
)

export default component.exports